<div class="payment-success-modal">
  <div class="payment-status">
    <img *ngIf="data.create" class="payment-success" src="assets/images/payment-modal-success.svg">
    <img *ngIf="!data.create" class="payment-fail" src="assets/images/payment-modal-fail.svg">
  </div>
  <div class="payment-message">
    <span *ngIf="data.create">Payment was processed successfully</span>
    <span *ngIf="!data.create">Payment was not processed</span>
  </div>
</div>
